import { PageSection } from '@/features/jobs/details/components/PageLayout'
import { SectionHeadline } from '@/components/SectionHeadline'
import {
  Card,
  CardContent,
  CardContentDecoration,
  CardSubtitle,
  CardTitle,
} from '@/components/Card'
import { Avatar } from '@/components/Avatar'
import { Button } from '@/components/Button'

export interface RelationManagerInfoSectionProps {
  testId?: string
  fullName: string
  avatarUrl?: string | null
  callLink?: string | null
}

export function RelationManagerSection({
  fullName,
  testId,
  avatarUrl,
  callLink,
}: RelationManagerInfoSectionProps) {
  return (
    <PageSection testId={testId}>
      <SectionHeadline>Your Relationship manager</SectionHeadline>
      <Card>
        <CardContent>
          <CardContentDecoration spacing="md">
            <Avatar subject={{ displayName: fullName, avatarUrl }} />
          </CardContentDecoration>
          <CardTitle>{fullName}</CardTitle>
          {callLink && (
            <CardSubtitle>
              <Button
                target="_blank"
                variant="text-inline"
                href={callLink}
                label="Schedule a Call"
              />
            </CardSubtitle>
          )}
        </CardContent>
      </Card>
    </PageSection>
  )
}
